import { useState, useEffect } from "react";
import { Liferay } from "../services/liferay/liferay.js";

export const useLiferayLanguage = (key, defaultValue = "") => {
    const [translation, setTranslation] = useState(defaultValue);

    useEffect(() => {
        const translatedValue = Liferay.Language.get(key);
        setTranslation(translatedValue !== key ? translatedValue : defaultValue);
    }, [key]);

    return translation;
};
